import type { UseMutationOptions } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { encodeSearchParams, sendJson } from '@hcr/api/shared'

import type { ProblemDetailsDto, UserOnboardingStartPayloadDto } from '../../dtos'
import type { UserOnboardingStartParams } from '../../models'

export const createUserOnboardingStartMutation =
  (baseUrl: string) =>
  (
    { ...params }: UserOnboardingStartParams,
    options?: Partial<UseMutationOptions<void, ProblemDetailsDto, UserOnboardingStartPayloadDto>>
  ) =>
    useMutation<void, ProblemDetailsDto, UserOnboardingStartPayloadDto>({
      ...options,
      mutationFn: body =>
        sendJson({
          body,
          method: 'POST',
          url: `${baseUrl}/user/start-registration${encodeSearchParams({ refSource: params.ref })}`,
        }),
    })
